<template>
    <div class="condition-status-historical-trends">
        <LoadingPanel
            v-model:collapsed="collapsed"
            :headline="t('generators.conditionStatus.content.historicalTrends.title')"
            collapsible
        >
            <div class="condition-status-historical-trends__panel">
                <ConditionStatusOilHistoricalTrendsSelector
                    :measurement-type="measurementType"
                    :measurement-point="measurementPoint"
                    :start-date="startDate"
                    :end-date="endDate"
                    @update:selector="onUpdateSelector"
                />
                <HistoricalTrendsChart
                    :measurement-type="measurementType"
                    :measurement-point="measurementPoint"
                    :start-date="selectedStartDate"
                    :end-date="selectedEndDate"
                />
            </div>
        </LoadingPanel>
    </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { startDateFormat, endDateFormat, TIMEFRAME_DEFAULT_END_DATE, timeframeStartDate } from '@/utils/date-utils'
import LoadingPanel from '@/components/panel/LoadingPanel.vue'
import ConditionStatusOilHistoricalTrendsSelector from '@/pages/generators/condition-status/sections/historical-trends/HistoricalTrendsSelector.vue'
import { HistoricalTrendsSelector } from '@/pages/generators/condition-status/sections/historical-trends/historical-trends-types'
import HistoricalTrendsChart from '@/pages/generators/condition-status/sections/historical-trends/HistoricalTrendsChart.vue'
import { useGeneratorsExportStateStore } from '@/store/generators/exportStateStore'

const collapsed = defineModel<boolean>('collapsed', { default: true })

const generatorsExportStateStore = useGeneratorsExportStateStore()

const { t } = useI18n()

const measurementType = ref<number | undefined>(undefined)
const measurementPoint = ref<number | undefined>(undefined)
const startDate = ref<string | undefined>(timeframeStartDate(15))
const endDate = ref<string | undefined>(TIMEFRAME_DEFAULT_END_DATE)

const selectedStartDate = computed(() => {
    return startDate.value && startDateFormat(startDate.value)
})

const selectedEndDate = computed(() => {
    return endDate.value && endDateFormat(endDate.value)
})

const onUpdateSelector = (selector: HistoricalTrendsSelector) => {
    measurementType.value = selector.measurementType
    measurementPoint.value = selector.measurementPoint
    startDate.value = selector.startDate
    endDate.value = selector.endDate

    generatorsExportStateStore.conditionStatusExportParameters.measurementType = selector.measurementType
    generatorsExportStateStore.conditionStatusExportParameters.measurementPoint = selector.measurementPoint
    generatorsExportStateStore.conditionStatusExportParameters.startDate = selector.startDate
    generatorsExportStateStore.conditionStatusExportParameters.endDate = selector.endDate
}
</script>

<style scoped lang="scss">
.condition-status-historical-trends {
    &__panel {
        display: flex;
        flex-direction: column;
        gap: $spacing-m;
    }
}

.coming-soon {
    height: 400px;

    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
